import './add';
import './add-related';
import './archive';
import './cancel';
import './complete';
import './confirm';
import './decline';
import './deposit';
import './payments';
import './read-message-templates';
import './respond';
import './statuses';
import './update';

import './appointment.component.js';
import './appointment.controller.js';
import './appointment.data.js';
import './appointment.service.js';
import './_appointment.styles.scss';



// WEBPACK FOOTER //
// ./components/appointments/appointment/index.js